import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import CustomerSettingSidebar from '../layouts/CustomerSettingSidebar'
// import Select from "react-select";

// import FeatherIcon from 'feather-icons-react';
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
// import { useFormik } from "formik";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const CustomerProfileSettings = () => {
  let { id } = localStorage.getItem('auth_id');

  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  
  const formik = useFormik({
    initialValues: {
      id: value.id,
      user_first_name: value.user_first_name,
      user_last_name: value.user_last_name,
      user_function: value.user_function,
      user_email: value.user_email
    },
    enableReinitialize: true,
    // validationSchema: EditUserSchema,
    onSubmit: (values, actions) => {
      axios
        .post("/customerportal/user/update", values, {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          actions.setSubmitting(false);

          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/customerportal/update-profile";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        }).catch((error) => {
          console.log(error);
          actions.setSubmitting(false);
        });
    },
  });

  useEffect(() => {
    axios
      .get(`/customerportal/user/edit/${localStorage.getItem('auth_id')}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          //toast.error(response.data.data.user);
          var user_data = response.data.data.user;
          setValue(user_data);
          
        }
      })
      .catch((error) => {
        console.log(error);
      });

  
  }, [id]);

  const customHandleInput = (event) => {
    const Input_name = event.name;
    delete backendErrors[Input_name];
  };

  const toggleMobileMenu = () => {
    setMenu(!menu)
  }
  
  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? 'slide-nav': ''}`}> 
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar /> 	<ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-6">
                <h3 className="page-title">Update Profile</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Update Profile</li>
                </ul>
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-xl-2 col-md-3">
              <CustomerSettingSidebar />
            </div>
            
            <div className="col-xl-10 col-md-9">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">User Information</h5>
                </div>
                <div className="card-body">
                   <FormikProvider value={formik}>
                   <form action="#" onSubmit={formik.handleSubmit}>
                    
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="user_first_name"
                            value={formik.values.user_first_name}
                            className="form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_first_name && (
                              <span className="form-error mt-1">
                                {backendErrors.user_first_name}
                              </span>
                            )}
                          </small>
                        </div>
                       
                        
                      </div>
                     
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Last Name</label>
                          <input
                            type="text"
                            value={formik.values.user_last_name}
                            name="user_last_name"
                            className="form-input form-control"
                             onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }} 
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_last_name && (
                              <span className="form-error mt-1">
                                {backendErrors.user_last_name}
                              </span>
                            )}
                          </small>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                      <div className="form-group">
                          <label>Email</label>
                          <input
                            type="text"
                            value={formik.values.user_email}
                            name="user_email"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            disabled
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_email && (
                              <span className="form-error mt-1">
                                {backendErrors.user_email}
                              </span>
                            )}
                          </small>
                        </div>
                      
                      </div>
                      <div className="col-md-12">
                      <div className="form-group">
                          <label>Function</label>
                          <input
                            type="text"
                            value={formik.values.user_function}
                            name="user_function"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_function && (
                              <span className="form-error mt-1">
                                {backendErrors.user_function}
                              </span>
                            )}
                          </small>
                        </div>
                      
                      </div>
                    </div>
                    <small>
                      
                      {backendErrors.status && (
                        <span className="form-error mt-1">
                          {backendErrors.status}
                        </span>
                      )}
                    </small>
                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={formik.isSubmitting}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                   </FormikProvider>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>		
  );
}

export default CustomerProfileSettings;